// PrivateRoute.js
// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";

// const isTokenExpired = (token) => {
//   if (!token) return true;
//   try {
//     const decoded = jwtDecode(token);
//     const currentTime = Date.now() / 1000;
//     return decoded.exp < currentTime;
//   } catch (error) {
//     console.error("Token decoding error:", error);
//     return true; // If there's an error decoding, treat it as expired
//   }
// };

// const PrivateRoute = () => {
//   const token = localStorage.getItem("token");
//   if (isTokenExpired(token)) {
//     localStorage.removeItem("token");
//     return <Navigate to='/' />;
//   }
//   return <Outlet />;
// };

// export default PrivateRoute;


import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { url } from "../configlink";
import { IdleTimerProvider, useIdleTimerContext } from "react-idle-timer";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import { logout } from "../store/slices/usersSlice";

const PrivateRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null means "unknown/loading"
  const navigate = useNavigate();
  
  const [remaining, setRemaining] = useState(0);
  let [expiryWarning, setExpiryWarning] = useState(false)
  let userId = useSelector((state) => state.user.user.UserId)
  const lastRefresh = useRef(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${url}/api/auth/validate`, {
          method: "GET",
          credentials: "include", // Include cookies
        });
    
        if (response.status === 200) {
          setIsAuthenticated(true);
        } else if (response.status === 401 || response.status === 403) {
          setIsAuthenticated(false);
          // console.log("Token invalid or missing");
        } else {
          console.error("Unexpected response status:", response.status);
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
        setIsAuthenticated(false);
      }
    };
    

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    // Show a loading spinner or placeholder while checking auth
    return <div>Loading...</div>;
  }

  const handleOnIdle = () => {
    // console.log('Admin is idle');
     setExpiryWarning(false)
        // alert('Session ended due to inactivity!')
        dispatch(logout());
    try {
          fetch(`${url}/api/auth/logout`, {
            method: "POST",
            credentials: "include", // Send cookies along with the request
          })
          .then(res => res.json())
          .then(data => {
            if(data.message==='Logout successful'){
              localStorage.removeItem('user_token_expiry')
			localStorage.setItem('userlogoutmessage', 1)
              navigate("/");
            }
          })
        } catch (error) {
          console.error(error);
          
        }
  }

  

  const handleOnAction = () => {
      setExpiryWarning(false)     
      
      const now = Date.now();
  
      // throttle refresh check to once every 1 minute
      if (now - lastRefresh.current < 60000) return;
  
      const expiry = localStorage.getItem('user_token_expiry'); // stored when login happens
      
      if(expiry) {
        const timeLeft = Number(expiry) - now;
    
        if (timeLeft < 5 * 60 * 1000) {
            fetch(`${url}/api/auth/refreshUserCookie?userId=${userId}`, {
                method: "POST",
                credentials:'include',
                // headers: {
                //   "Content-Type": "application/json",
                // },
                // body: JSON.stringify({userId: userId}),
            })
            .then(res => res.json())
            .then(data => {
              if (data.message === 'success'){
                localStorage.setItem('user_token_expiry', (Date.now() + 30 * 60 * 1000).toString());
                // console.log('User Cookie extended');
                lastRefresh.current = now;
              }
            })
            .catch(err => {
              console.log("Refresh token error"); 
            })
        }
      }
    };

  
  
    const RemainingTime = () => {
      const idleTimer = useIdleTimerContext();
  
      useEffect(() => {
        const interval = setInterval(() => {
          const timeLeft = idleTimer.getRemainingTime();
  
          
          const minutes = Math.floor(timeLeft / 1000 / 60);
          const seconds = Math.floor((timeLeft / 1000) % 60);
          
          if(minutes < 5){
            setExpiryWarning(true)
          }
    
          const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          setRemaining(formatted);
        }, 1000);
    
        return () => clearInterval(interval);
      }, [idleTimer]);
    
        return (
        <>
        <p className={`text-sm text-gray-500 px-10 fixed top-0 left-0`}>
			Inactivity Timer: {remaining}
        </p>
        </>
        );
    };

  return isAuthenticated ? 
    <IdleTimerProvider
    timeout={1000 * 60 * 30}
    onIdle={handleOnIdle}
    onAction={handleOnAction}
    debounce={500}
    >
    {expiryWarning && 
        <>
        <div className="w-full h-[100vh] fixed top-0 left-0 bg-black opacity-80 z-20 flex justify-center items-center">    
        </div>
        <div className=" fixed top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 w-[400px] h-[200px] z-30 bg-gray-300 rounded-md flex items-center justify-center">
			<p className="text-2xl text-center">Session expiring soon!<br/>{remaining}</p>
        </div>
		</>
    }
    <RemainingTime />
    <Outlet />
	</IdleTimerProvider>
	: 
	<Navigate to="/" />;
};

export default PrivateRoute;

